// extracted by mini-css-extract-plugin
export default {"popupBody":"u7GTy_lA3sje7vQkFVwva","featuredImage":"_2AnXXa2FpJtqcMo3S7CN0S"};